import React, {useState} from 'react'
import {Box} from '@miro-site/core'
import type {BoxProps} from '@miro-site/core'
import Header from './Header'
import Content from './Content'

export interface ItemProps extends BoxProps {
  children: React.ReactNode
  header: string
  onExpand?: () => void
  onCollapse?: () => void
}

const Item: React.FC<ItemProps> = ({children, header, onExpand, onCollapse, ...props}) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const onClick = () => {
    if (!isExpanded && onExpand) {
      onExpand()
    }
    if (isExpanded && onCollapse) {
      onCollapse()
    }

    setIsExpanded(!isExpanded)
  }

  return (
    <Box as="section" {...props}>
      <Header onClick={onClick} isExpanded={isExpanded}>
        {header}
      </Header>
      <Content isExpanded={isExpanded}>{children}</Content>
    </Box>
  )
}

export default Item
